"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var typestyle_1 = require("typestyle");
var typestyle_2 = require("typestyle");
exports.classes = typestyle_2.classes;
function cssClass(name) {
    var styles = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        styles[_i - 1] = arguments[_i];
    }
    return typestyle_1.style.apply(void 0, styles.concat([{
            $debugName: "nlpdatasourceowner_" + name,
            $unique: true,
        }]));
}
exports.cssClass = cssClass;
//# sourceMappingURL=index.js.map